<template>
  <div class="notice">
<!--    <top-bar :title="'人大信箱'" :left="true"></top-bar>-->
    <div class="addBtn" @click="goAdd">
      <img src="@/assets/img/weAdd.png" alt="">
    </div>
    <div class="cont">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getDataList" v-if="dataList.length > 0" offset="10">
        <van-cell v-for="item in dataList" :key="item.id"  @click="toDetail(item.id)">
          <div class="item">
            <van-row>
              <van-col :span="20">
                <p>{{item.letterTitle}}</p>
              </van-col>
              <van-col :span="4">
                <span v-if="item.checkStatus === 0" style="color: #E61313;">待回复</span>
                <span v-if="item.checkStatus === 3" style="color: #1E7DFF;">已回复</span>
              </van-col>
            </van-row>
            <van-row>
              <van-col :span="22">
                <span>{{item.createTime}}</span>
              </van-col>
              <van-col :span="2">
                <van-icon name="arrow" />
              </van-col>
            </van-row>
          </div>
        </van-cell>
      </van-list>
      <van-empty description="没有数据哦" v-if="dataList.length < 1"/>
    </div>
  </div>
</template>

<script>
import topBar from '@/components/topBar/topBar'
export default {
  components :{
    topBar
  },
  data() {
    return {
      searchValue: '',
      loading: false,
      finished: false,
      limit: 10,
      page: 0,
      dataList: []
    };
  },
  methods: {
    toDetail (id) {
      this.$router.push('/peopleMail-info?id=' + id)
    },
    goAdd () {
      this.$router.push('/peopleMail-info')
    },
    getDataList () {
      this.page++
      this.$toast.loading({duration: 0,message: '加载中...',forbidClick: true,});
      this.$http({
        url: this.$http.adornUrl('/wxapp/future/letter/list'),
        method: 'post',
        params: this.$http.adornParams({
          page: this.page,
          limit: this.limit,
          orgId: this.$orgId,
          userId: this.$globalData.userInfo.userId
        })
      }).then(({data})=> {
        if (data.code == 0) {
          if (this.dataList.length == data.page.totalCount) {
            this.finished = true
          }
          this.dataList = this.dataList.concat(data.page.list)
          // 加载状态结束
          this.dataList.sort(function(a,b){return a.createTime < b.createTime ? 1 : -1})
          this.loading = false;
          this.$toast.clear()
        }
        this.$toast.clear()
      },err=> {this.$toast.clear()})
      // 数据全部加载完成
    },
    onSearch(val) {
      this.page = 0
      this.dataList = []
      this.getDataList()
    },
    onCancel() {
      this.page = 0
      this.dataList = []
      this.searchValue = ''
      this.getDataList()
    },
  },
  created () {
    this.getDataList()
  }
}
</script>

<style lang="scss" scoped>
.notice {
  padding-top: 100px;
  min-height: 100vh;
  background-color: #f5f5f5;
  .cont {
    background-color: #f5f5f5;
    .van-cell {
      padding: 10px 10px;
    }
    .item {
      .van-row:nth-child(1) .van-col:nth-child(2){
        margin-top: 10px;
        padding-left: 22px;
      }
      .van-row:nth-child(2) .van-col:nth-child(2){
        padding-left: 22px;
      }
      p {
        margin: 10px 0;
        font-size: 30px;
        font-weight: 600;
      }
      span {
        font-size: 26px;
      }
    }
  }
}
.addBtn {
  position: fixed;
  right: 40px;
  bottom: 130px;
  z-index: 999;
  width: 160px;
  height: 160px;
  img {
    width: 100%;
  }
}
.van-icon-arrow::before {
  margin-top: 10px;
}
</style>
